export const PRODUCT_ACQUISITION_COST_RIGHT_MENU = {
  SET_INITIAL_SITUATION:'PRODUCT_ACQUISITION_COST_RIGHT_MENU.SET_INITIAL_SITUATION',
  SET_INITIAL_ACQUISITION_COST:'PRODUCT_ACQUISITION_COST_RIGHT_MENU.SET_INITIAL_ACQUISITION_COST',
  SET_INITIAL_STATE_MENU:'PRODUCT_ACQUISITION_COST_RIGHT_MENU.SET_INITIAL_STATE_MENU',
  SET_FILTERS:'PRODUCT_ACQUISITION_COST_RIGHT_MENU.SET_FILTERS',
}